/**
 * Audit & Assurance — Page Exports
 *
 * Each page uses its dedicated V2 component:
 *   Audit Trail        → AuditTrailPage.js (timeline + integrity verification)
 *   Audit Packs        → AuditPacksPage.js (pack generator + downloads)
 *   Assurance Readiness → AssuranceReadinessPageV2.jsx (readiness scores + gaps)
 *   Evidence Lineage   → EvidenceLineagePageV2.jsx (flow diagram + table view)
 */
import AuditTrailPageComponent from './AuditTrailPage';
import AuditPacksPageComponent from './AuditPacksPage';
import AssuranceReadinessPageV2 from './AssuranceReadinessPageV2';
import EvidenceLineagePageV2 from './EvidenceLineagePageV2';

// Audit Trail → dedicated 507-line component with timeline + integrity verification
export function AuditTrailPage() {
  return <AuditTrailPageComponent />;
}

// Audit Packs → dedicated 553-line pack generator
export function AuditPacksPage() {
  return <AuditPacksPageComponent />;
}

// Assurance Readiness → V2 738-line readiness assessment
export function AssuranceReadinessPage() {
  return <AssuranceReadinessPageV2 />;
}

// Evidence Lineage → V2 1002-line lineage with flow diagrams
export function EvidenceLineagePage() {
  return <EvidenceLineagePageV2 />;
}

// Methodology Transparency → L2 spine runs (calculation derivations)
export { default as MethodologyTransparencyPage } from './MethodologyTransparencyPage';

export default AuditTrailPage;
